export enum CardNetwork {
  VISA = "visa",
  MASTERCARD = "mastercard",
  AMERICAN_EXPRESS = "american_express",
  DISCOVER = "discover",
}
